const STORAGE_KEY = 'developmentexpress_recon_export_history';
const MAX_ITEMS = 20;

export function loadExportHistory() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function pushExportHistory(entry) {
  const list = loadExportHistory();
  const next = [
    {
      id: `${Date.now()}`,
      at: new Date().toISOString(),
      ...entry,
    },
    ...list,
  ].slice(0, MAX_ITEMS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  return next;
}
